/**
 * Regle metier : REF-R22 (PRODUIT/domaine/16_referentiels.md)
 * Decision : D-ALIAS-01 (PLAN/decisions_developpement.md)
 *
 * Resolution d'affichage des 4 entites tierces (Etablissements, Centres,
 * Transporteurs, Entreprises Travaux) : alias trim non vide sinon raison sociale.
 *
 * Utiliser partout dans l'UI applicative, le corps + objet des e-mails Brevo,
 * les exports Excel, le tri et la recherche. JAMAIS dans les payloads
 * Carbone (PDF officiels), Trackdechets, Pennylane, ni les PJ Carbone des
 * e-mails Brevo (cf. REF-R23).
 */
export function displayName(entity: {
  alias?: string | null;
  raisonSociale: string;
}): string {
  return entity.alias?.trim() || entity.raisonSociale;
}
